import Econlaw from './assets/Econlaw.png'

export const projectData = [{
    id: 0,
    imageUrl: 'https://img.itch.zone/aW1nLzE0NjYwMzA3LnBuZw==/315x250%23c/nW%2FgiG.png',
    title: 'Laser Link',
    description: 'Game about a robot controlling laser cannons. Developed for the Bitter Sails New Year, New Skills game jam',
    type: 'game',
    link: 'https://jasbrela.itch.io/laser-link'
},
{
    id: 1,
    imageUrl: Econlaw,
    title: 'Economou & Economou law office',
    description: 'Search Engine Optimization in content, Google Adwords campaign monitoring',
    type: 'application',
    link: 'https://www.econlaw.gr'
},
{
    id: 2,
    imageUrl: "https://via.placeholder.com/300",
    title: 'Hellenic Police Incident Map',
    description: 'Incident Map and Table for recording incidents',
    type: 'application'
},
{
    id: 3,
    imageUrl: "https://img.itch.zone/aW1nLzE3NzgxMzMxLnBuZw==/315x250%23c/Qn4%2FDe.png",
    title: 'Barn Defence',
    type: 'game',
    link: 'https://esaltzherr.itch.io/barn-defense'
},
{
    id: 4,
    imageUrl: "https://img.itch.zone/aW1nLzE3NzgxMzMxLnBuZw==/315x250%23c/Qn4%2FDe.png",
    title: 'Antiques App',
    type: 'application',
    link: 'https://esaltzherr.itch.io/barn-defense'
},

]